import React, { Component } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../redux/root-action';
import DeleteFutureIncome from './DeleteFutureIncome';
import DeleteFutureExpense from './DeleteFutureExpense';
import FutureIncomeModal from './FutureIncomeModal';
import AddFutureExpense from './AddFutureExpense';
import AddFutureIncome from './AddFutureIncome';

const eventViewComponentMap: { [key: string]: any } = {
  ADD_FUTURE_EXPENSE: AddFutureExpense,
  ADD_FUTURE_INCOME: AddFutureIncome,
  FUTURE_INCOME_MODAL: FutureIncomeModal,
  DELETE_FUTURE_INCOME: DeleteFutureIncome,
  DELETE_FUTURE_EXPENSE: DeleteFutureExpense,
};

class EventModal extends Component<any, any> {
  render(): JSX.Element {
    const { currentView } = this.props;
    const EventView = eventViewComponentMap[currentView];
    return <EventView />;
  }
}

const mapStateToProps = ({ event }: any) => ({
  currentView: event.currentView,
});

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
})(EventModal);
